import React from "react";
import { Facebook, Twitter, Linkedin, Link2, MessageCircle } from "lucide-react";
import { toast } from "sonner";

const SocialShare = ({ url, title, compact = false }) => {
  const shareUrl = encodeURIComponent(url || window.location.href);
  const shareTitle = encodeURIComponent(title || document.title);

  const shareLinks = [
    {
      name: "Facebook",
      icon: Facebook,
      url: `https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`,
      color: "bg-blue-600 hover:bg-blue-700"
    },
    {
      name: "Twitter",
      icon: Twitter,
      url: `https://twitter.com/intent/tweet?url=${shareUrl}&text=${shareTitle}`,
      color: "bg-sky-500 hover:bg-sky-600"
    },
    {
      name: "LinkedIn",
      icon: Linkedin,
      url: `https://www.linkedin.com/shareArticle?mini=true&url=${shareUrl}&title=${shareTitle}`,
      color: "bg-blue-700 hover:bg-blue-800"
    },
    {
      name: "WhatsApp",
      icon: MessageCircle,
      url: `https://wa.me/?text=${shareTitle}%20${shareUrl}`,
      color: "bg-green-600 hover:bg-green-700"
    }
  ];

  const copyToClipboard = () => {
    navigator.clipboard.writeText(decodeURIComponent(shareUrl));
    toast.success("Link copied to clipboard!");
  };

  if (compact) {
    return (
      <div className="flex items-center gap-2">
        {shareLinks.map((link) => (
          <a
            key={link.name}
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            className={`w-8 h-8 rounded-full ${link.color} text-white flex items-center justify-center transition-colors`}
            title={`Share on ${link.name}`}
            data-testid={`share-${link.name.toLowerCase()}`}
          >
            <link.icon className="w-4 h-4" />
          </a>
        ))}
        <button
          onClick={copyToClipboard}
          className="w-8 h-8 rounded-full bg-gray-600 hover:bg-gray-700 text-white flex items-center justify-center transition-colors"
          title="Copy link"
          data-testid="share-copy"
        >
          <Link2 className="w-4 h-4" />
        </button>
      </div>
    );
  }

  return (
    <div className="flex flex-wrap items-center gap-3">
      <span className="text-sm text-gray-500">Share:</span>
      {shareLinks.map((link) => (
        <a
          key={link.name}
          href={link.url}
          target="_blank"
          rel="noopener noreferrer"
          className={`flex items-center gap-2 px-3 py-1.5 rounded-full ${link.color} text-white text-sm transition-colors`}
          data-testid={`share-${link.name.toLowerCase()}`}
        >
          <link.icon className="w-4 h-4" />
          <span className="hidden sm:inline">{link.name}</span>
        </a>
      ))}
      <button
        onClick={copyToClipboard}
        className="flex items-center gap-2 px-3 py-1.5 rounded-full bg-gray-600 hover:bg-gray-700 text-white text-sm transition-colors"
        data-testid="share-copy"
      >
        <Link2 className="w-4 h-4" />
        <span className="hidden sm:inline">Copy Link</span>
      </button>
    </div>
  );
};

export default SocialShare;
